import React from 'react'
import Index from '../../Components/tutor/Index'

import BackgroundProps from './Background'

function Home() {
  return (

  <BackgroundProps child={<Index/>} />
    
  )
}

export default Home
